import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { flexCenter } from './_shared/styled-mixins';
import React from 'react';
import { mq } from './_shared/media';
import { StyledSection } from './_shared/styled-section';
import { StyledH1 } from './_shared/styled-headings';
import { StyledP } from './_shared/styled-headings';

const StyledHeroSection = styled(StyledSection)`
  min-height: calc(120vh - 2 * var(--header-height));
  position: relative;
  z-index: 1;
  padding: 3rem calc((var(--space) / 2)) 2rem;

  ${mq.gt.sm} {
    min-height: calc(120vh - var(--header-height));
    padding: 3rem calc((var(--space) / 2)) 2rem;
  }
`;

const StyledTagline = styled(StyledH1)`
  font-size: 1.8rem;
  max-width: 28ch;
  line-height: 1.1;
  margin: 0 auto;
  color: var(--title-color);
  word-break: break-word;
  text-align: center;

  ${mq.gt.sm} {
    font-size: 42px;
    max-width: 24ch;
  }
`;
const StyledDescription = styled(StyledP)`
  padding: 0.5rem 0 2rem;
  max-width: 40ch;
  color: var(--title-color);

  ${mq.lt.sm} {
    font-size: 16px;
  }

  strong {
    color: var(--secondary-color);
  }
`;

const Buttons = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-column-gap: 1rem;
  padding-bottom: 3rem;

  ${mq.lt.sm} {
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 1rem;
    min-width: 250px;
    padding-bottom: 4rem;
  }
`;

const ButtonLink = styled.a`
  ${flexCenter};
  text-decoration: none;
  color: var(--primary-color) !important;
  background-color: var(--secondary-color);
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 800;
  color: #fff !important;
  white-space: nowrap;
  padding: 0.6rem 1.2rem;
  border-radius: var(--radius);
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;

  &:hover {
    color: var(--darkbg-content-color) !important;
    background-color: var(--bright-purple-color);
  }
`;

const DiversityHero = ({ data }) => {
  const { headerText, ctaLink, ctaLabel, summary } = data;

  return (
    <StyledHeroSection>
      <StyledTagline>{headerText}</StyledTagline>
      <StyledDescription dangerouslySetInnerHTML={{ __html: summary }} />
      <Buttons>
        <ButtonLink href={ctaLink}>{ctaLabel}</ButtonLink>
      </Buttons>
    </StyledHeroSection>
  );
};

DiversityHero.propTypes = {
  data: PropTypes.object.isRequired,
};

export default DiversityHero;
